export default __webpack_public_path__ + "static/media/ref.3fbad8db.png";